{
  "AdmittedBusinesses": "Admitted to the incubation program this year",
  "AdvicedAccessToOtherTools": "Have you assisted the company in processes to gain access to other instruments this year?",
  "BusinessDigitalCompetence": "Participates in competence-building initiatives within digitalization",
  "BusinessesAdvicedFromOthers": "Receives advice from other program operators",
  "BusinessesInOtherPrograms": "Admitted to programs with other program operators",
  "BusinessesReferredToOthers": "Referred to other program operators",
  "CompetenceProjectsWithOthers": "Completed network projects together with other program operators",
  "CooperatingBusinesses": "",
  "DigitalCompetenceEmployees": "Employees have participated in competence-building initiatives within digitalization",
  "DigitalizationInBusinessPlan": "Has digitalization as a central element in the business model",
  "ExportCompetenceBuilding": "Offers competence-building initiatives within export",
  "ExportTurnover": "Does the entire or part of the turnover consist of export?",
  "FemaleLeadership": "Does the company have a female founder and/or female CEO and/or female chairman of the board?",
  "InternationalCooperation": "Has the company been put in contact with an international actor?",
  "InternationalMarket": "Does the company have an international market?",
  "NewBusinesses": "Newly established",
  "NewIdeas": "Has new idea",
  "OtherBusinessesAdviced": "Receives advice",
  "PaidEquity": "Equity paid into the company during the year (reported in absolute numbers)",
  "SRLScaleIncrease": "What level on the SRL scale is the company placed at?",
  "SupportedBusinesses": "Innovation support",
  "SustainabilityBusinesses": "Receives competence-building initiatives within sustainability",
  "SustainabilityEmployees": "Competence-building initiatives within sustainability that employees in the incubator/science park have participated in during the year",
  "SustainabilityInBusinessModel": "Has sustainability as a central element in their business model",
  "TaxonomyQuestions": "Does the company (potentially) have a significant positive or negative impact on any of the environmental objectives?"
}
